module.exports = __webpack_public_path__ + "img/social_icon_youtube.5560e037.svg";